import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from "moment";

Vue.use(Vuex);

const controller = new AbortController();

const state = {
    post_types: [],
    posts: [],
    post: {},
    post_details: {},
    post_filters: {
        q: '',
        date_from: '',
        date_to: '',
        user_id: '',
        menu_id: 1,
        type: '',
    },
    most_used_keywords: [],
    google_user: {},
    posts_loaded: false,
}

const actions = {
    getPosts({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoadingStatus', true);
            commit('setPostsLoaded', false);
            axios.get('/api/admin-posts', {
                params: payload.filters,
            })
                .then((response) => {
                    commit('setPosts', response.data.data);
                    commit('setPagination', response.data.pagination);
                    commit('setLoadingStatus', false);
                    commit('setPostsLoaded', true);
                    resolve(response.data.data);
                }).catch((e) => {
                console.log('unable to get posts', e);
                commit('setLoadingStatus', false);
                reject(e);
            })
        })
    },
    getPost({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoadingStatus', true);
            axios.get('/api/posts/'+payload.id, {
            }).then((response) => {
                commit('setPostDetails', response.data.data);
                resolve(response.data.data);
                commit('setLoadingStatus', false);
            }).catch((e) => {
                console.log('unable to get post', e);
                commit('setLoadingStatus', false);
                reject(e);
            })
        })
    },
    addPost({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/posts/add', payload).then((response) => {

                if(response.data && response.data.status == 'ok') {
                    commit('setPostDetails', response.data.data);
                        commit(
                            (response.data.data.menu_type == 'post' ?
                            'setSuccessMessage'
                            : 'setInfoMessage'), response.data.message);

                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    updatePost({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/posts/'+payload.id, payload).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setPostDetails', response.data.data);
                    commit(
                        (response.data.data.menu_type == 'post' ?
                            'setSuccessMessage'
                            : 'setInfoMessage'), response.data.message);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    deletePost({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.delete('/api/posts/' + payload.id).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setSuccessMessage', response.data.message);

                    if(!payload.list) {
                        commit('setPostDetails', response.data.data);
                    } else {
                        commit('removePostFromList', payload.id);
                    }
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    getPostTypes({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/posts/types', {
                params: payload,
            })
                .then((response) => {
                    commit('setPostTypes', response.data.data);
                    resolve(response.data.data);
                }).catch((e) => {
                console.log('unable to get postTypes', e);
                reject(e);
            })
        })
    },
    getMostUsedKeywords({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/posts/most-used-keywords/'+payload.menu_path, {
                params: payload,
            })
                .then((response) => {
                    let kws = [];

                    if(response.data.most_used_keywords) {
                        kws = Object.keys(response.data.most_used_keywords);
                    }
                    commit('setMostUsedKeywords', kws);
                    resolve(kws);
                }).catch((e) => {
                console.log('unable to get most used keywords', e);
                reject(e);
            })
        })
    },
}

const mutations = {
    setPosts(state, payload) {
        if(payload) {
            state.posts = payload;
        } else {
            state.posts = [];
        }
    },
    setPostDetails(state, payload) {
        state.post_details = payload;
    },
    removePostFromList(state, payload) {
        state.posts.splice(state.posts.indexOf(state.posts.find(inv => inv.id == payload)), 1);
    },
    setPostFilters(state, payload) {
        state.post_filters = payload;
    },
    setPostTypes(state, payload) {
        state.post_types = payload;
    },
    setMostUsedKeywords(state, payload) {
        state.most_used_keywords = payload;
    },
    setGoogleUser(state, payload) {
        state.google_user = payload;
    },
    setPostsLoaded(state, payload) {
        state.posts_loaded = payload;
    },
}

const getters = {
    posts: state => state.posts,
    postDetails: state => state.post_details,
    postFilters: state => state.post_filters,
    postTypes: state => state.post_types,
    mostUsedKeywords: state => state.most_used_keywords,
    googleUser: state => state.google_user,
    postsLoaded: state => state.posts_loaded,
}

export const postStore = {
    state,
    actions,
    mutations,
    getters
}
